import translate from "../locales";
import { Helmet } from "react-helmet-async";

export default function Header() {
  return (
    <header className="page__header">
      <Helmet>
        <title>{translate("app_title")}</title>
      </Helmet>
      <h2 className="page__title">{translate("app_title")}</h2>
    </header>
  );
}
